<template>
  <div class="loading-quote" v-visibility-change="visibilityChange">
    <div class="copyright">
      <div class="text">In esclusiva su</div>
      <div class="audible-logo">
        <img style="padding-left: 12px; width: 150px;" src="/images/audible_logo_grey.svg" alt="">
      </div>
    </div>
    <div :class="['btn-volume', { 'volume-muted' : isMuted }]" @click="clickVolume">
      <div class="text">Volume</div>
        <div>
          <img src="/images/icon_volume.svg" alt="">
        </div>
    </div>
    <div v-if="showBtn" @click="clickEntra" class="btn-cta">Entra</div>
    <div v-if="showBtn" @click="finishedAnimation" class="btn-salta">Salta ></div>
    <div class="quote-container">
      <div class="quote-text">
        <div class="row-cit row-cit-1">E come ‘l volger del ciel de la luna</div>
        <div class="row-cit row-cit-2">cuopre e discuopre i liti sanza posa,</div>
        <div class="row-cit row-cit-3">così fa di Fiorenza la Fortuna:</div>
        <div class="row-cit row-cit-4" style="padding-top: 32px;">per che non dee parer mirabil cosa</div>
        <div class="row-cit row-cit-5">ciò ch’io dirò de li alti Fiorentini</div>
        <div class="row-cit row-cit-6">onde è la fama nel tempo nascosa.”</div>
      </div>
      <div class="quote-cit">
        Paradiso, Canto XVI, 82-87
      </div>
    </div>
    <div class="progress-bar" :style="'width: '+widthBar+'vw;'"/>
  </div>
</template>
<script>
import gsap from "gsap";
import { TimelineMax } from 'gsap'
export default {
  props: ["content"],
  data() {
    return {
      timeline: null,
      progressBar: null,
      widthBar: null,
      audio: null,
      showBtn: null,
      isMuted: false
    };
  },
  mounted() {
    this.showBtn = true
    this.timeline = gsap.timeline({onStart: this.startAnimation,onUpdate: this.showProgress, onComplete: this.finishedAnimation, paused: true});
    this.timeline.fromTo('.quote-container .quote-text .row-cit-1', {autoAlpha: 0}, {autoAlpha: 1, delay: .5, duration: 1});
    this.timeline.fromTo('.quote-container .quote-text .row-cit-2', {autoAlpha: 0}, {autoAlpha: 1, duration: 1});
    this.timeline.fromTo('.quote-container .quote-text .row-cit-3', {autoAlpha: 0}, {autoAlpha: 1, duration: 1});
    this.timeline.fromTo('.quote-container .quote-text .row-cit-4', {autoAlpha: 0}, {autoAlpha: 1, duration: 1});
    this.timeline.fromTo('.quote-container .quote-text .row-cit-5', {autoAlpha: 0}, {autoAlpha: 1, duration: 1});
    this.timeline.fromTo('.quote-container .quote-text .row-cit-6', {autoAlpha: 0}, {autoAlpha: 1, duration: 1});
    this.timeline.fromTo('.quote-container .quote-cit', {opacity: 0}, {opacity: 1, duration: 5});
    this.timeline.to('.quote-container', {opacity: 0, duration: .5});

    if( !this.audio ){
      this.audio = new Audio('audio/cit.mp3');
      this.audio.onended = this.endAudio
      this.audio.ontimeupdate = this.audioPlaying
      this.audio.oncanplay = this.audioCanPlay
    }
    this.widthBar = 0
    this.progressBar = this.$el.querySelector('.progress-bar')

  },
  methods: {
    visibilityChange(evt, hidden){
      if( hidden ){
        if( this.audio.played.length != 0 )
          this.audio.pause()
      }
      else{
        if( this.audio.played.length != 0 )
          this.audio.play()
      }
    },
    clickEntra(){
      if( !this.timeline )
        return

      this.showBtn = false
      if(this.audio){
        this.audio.play();
      }
      this.timeline.duration(38).play()
    },
    startAnimation(){
    },
    audioPlaying(){
    },
    endAudio(){
      this.audio = null
    },
    showProgress(){
      this.widthBar = this.timeline.progress() * 100
    },
    finishedAnimation(event){
      this.$emit('finishedLoading', true)
    },
    audioCanPlay(){
    },
    clickVolume(){
      if( this.isMuted ){
        this.isMuted = false
        this.audio.muted = false
      }
      else{
        this.isMuted = true
        this.audio.muted = true
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .loading-quote{
    display: flex;
    flex-direction: column;
    align-items: center;
    .copyright{
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-top: 32px;
      .text{
        @include mdf-copyright;
      }
    }
    .btn-cta{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      display: flex;
      justify-content: center;
      align-items: center;
      height: 55px;
      width: 150px;
      border: 2px solid $mdf-darkblue;
      background-color: $mdf-darkblue;
      box-shadow: 0 0 10px 1px $mdf-white;
      margin-top: 21px;
      cursor: pointer;
      @include mdf-cta-text;
      &:hover{
        transform: translate(-50%,-50%) scale(1.1);
        transition: transform .7s;
      }
    }
    .btn-salta{
      position: absolute;
      top: 70%;
      @include mdf-copyright;
      text-decoration: underline;
      cursor: pointer;
    }
    .btn-volume{
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      padding-top: 24px;
      .text{
        padding-bottom: 12px;
        @include mdf-ui-volume;
      }
    }
    .volume-muted{
      opacity: 0.4
    }
    .quote-container{
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-top: 24px;
      z-index: -1;
      .quote-text{
        .row-cit{
          @include mdf-cit-opening;
        }
      }
      .quote-cit{
        padding-top: 24px;
        @include mdf-cit-source;
      }
    }
    .progress-bar{
      position: absolute;
      height: 10px;
      top: 0px;
      background-color: $mdf-darkblue;
    }
  }

  /* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  .loading-quote{
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    .quote-container{
      width: 100%;
      .quote-text{
        .row-cit{
          font-size: 12px;
          line-height: 24px;
        }
      }
    }
    .copyright{
      position: relative;
      padding-top: 32px !important;
      .text{
        font-size: 12px;
      }
      .audible-logo{
        img{
          width: 100px;
        }
      }
    }
    .btn-cta{
      position: relative;
      top: 0%;
      left: 0%;
      transform: none;
    }
  }
}

/* Portrait and Landscape */
@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (-webkit-min-device-pixel-ratio: 1) {
    .loading-quote{
    .quote-container{
      .quote-text{
        .row-cit{
          font-size: 21px;
        }
      }
    }
    .copyright{
      .text{
      }
      .audible-logo{
        img{
        }
      }
    }
    .btn-cta{
    }
  }
}
</style>
